import Accordion from './Accordion';
import Carousel from './Carousel';
import Feature from './HomepageFeature';
import FeaturedCollections from './FeaturedCollections';
import Hero from './HomepageHero';
import { ShopBlocks } from './ShopBlocks';
export var COMPONENTS = {
  ACCORDION: Accordion,
  CAROUSEL_CUSTOM: Carousel,
  CAROUSEL_PRODUCT: Carousel,
  CAROUSEL_UGC: Carousel,
  COLLECTIONS: FeaturedCollections,
  FEATURE: Feature,
  HERO: Hero,
  SHOP: ShopBlocks
};